
window.global ||= window;
// import { LexRuntimeV2 } from "@aws-sdk/client-lex-runtime-v2";
  import  AudioControl from "./control";
  // import AWS from "aws-sdk";
  var DEFAULT_LATEST = '$LATEST';
  var DEFAULT_CONTENT_TYPE = 'audio/x-l16; sample-rate=16000';
  var DEFAULT_USER_ID = 'userId';
  var DEFAULT_ACCEPT_HEADER_VALUE = 'audio/mpeg';
  var MESSAGES = Object.freeze({
    PASSIVE: 'Passive',
    LISTENING: 'Listening',
    SENDING: 'Sending',
    SPEAKING: 'Speaking'
  });

  var lexruntime, audioControl = new AudioControl({ checkAudioSupport: false });

  const conversation = function(config, onStateChange, onSuccess, onError, onAudioData) {
    var currentState;

    // Apply default values.
    this.config = applyDefaults(config);
    this.lexConfig = this.config.lexConfig;
    this.messages = MESSAGES;
    onStateChange = onStateChange || function() { /* no op */ };
    this.onSuccess = onSuccess || function() { /* no op */ };
    this.onError = onError || function() { /* no op */ };
    this.onAudioData = onAudioData || function() { /* no op */ };

    // Validate input.
    // if (!this.config.lexConfig.botName) {
    //   this.onError('A Bot name must be provided.');
    //   return;
    // }
    // if (!AWS.config.credentials) {
    //   this.onError('AWS Credentials must be provided.');
    //   return;
    // }
    // if (!AWS.config.region) {
    //   this.onError('A Region value must be provided.');
    //   return;
    // }

    lexruntime = this.config.lexConfig.lexRuntime;

    this.onSilence = function() {
      if (config.silenceDetection) {
        audioControl.stopRecording();
        currentState.advanceConversation();
      }
    };

    this.transition = function(conversation) {
      currentState = conversation;
      var state = currentState.state;
      onStateChange(state.message);

      // If we are transitioning into SENDING or SPEAKING we want to immediately advance the conversation state
      // to start the service call or playback.
      if (state.message === state.messages.SENDING || state.message === state.messages.SPEAKING) {
        currentState.advanceConversation();
      }
      // If we are transitioning in to sending and we are not detecting silence (this was a manual state change)
      // we need to do some cleanup: stop recording, and stop rendering.
      if (state.message === state.messages.SENDING && !this.config.silenceDetection) {
        audioControl.stopRecording();
      }
    };

    this.advanceConversation = function() {
      audioControl.supportsAudio(function(supported) {
        if (supported) {
          currentState.advanceConversation();
        } else {
          onError('Audio is not supported.');
        }
      });
    };

    this.updateConfig = function(newValue) {
      this.config = applyDefaults(newValue);
      this.lexConfig = this.config.lexConfig;
    };

    this.reset = function() {
      audioControl.clear();
      currentState = new Initial(currentState.state);
    };

    currentState = new Initial(this);

    return {
      advanceConversation: this.advanceConversation,
      updateConfig: this.updateConfig,
      reset: this.reset
    };
  };

  var Initial = function(state) {
    this.state = state;
    state.message = state.messages.PASSIVE;
    this.advanceConversation = function() {
      audioControl.startRecording(state.onSilence, state.onAudioData, state.config.silenceDetectionConfig);
      state.transition(new Listening(state));
    };
  };

  var Listening = function(state) {
    this.state = state;
    state.message = state.messages.LISTENING;
    this.advanceConversation = function() {
      audioControl.exportWAV(function(blob) {
        // console.log(blob);
        state.audioInput = blob;
        state.transition(new Sending(state));
      });
    };
  };

  var Sending = function(state) {
    this.state = state;
    state.message = state.messages.SENDING;
    this.advanceConversation = function() {
      state.lexConfig.inputStream = state.audioInput;
      state.lexConfig.botName = undefined;
      lexruntime.recognizeUtterance(state.lexConfig, function(err, data) {
        console.log(err);
        if (err) {
          state.onError(err);
          state.transition(new Initial(state));
        } else {
          if (data.audioStream) {
            convertReadableStreamToArrayBuffer(data.audioStream)
              .then((arrayBuffer) => {
                state.audioOutput = {
                  ...data,
                  audioArrayBuffer: arrayBuffer,
                };
                state.transition(new Speaking(state));
                state.onSuccess(data, arrayBuffer);
              })
              .catch((error) => {
                console.error('Error converting audio stream:', error);
                state.transition(new Initial(state));
              });
          } else {
            state.audioOutput = data;
            state.transition(new Speaking(state));
            state.onSuccess(data);
          }
        }
      });
    };
  };
  
  function convertReadableStreamToArrayBuffer(readableStream) {
    return new Promise((resolve, reject) => {
      const reader = readableStream.getReader();
      const chunks = [];
  
      function read() {
        reader.read().then(({ done, value }) => {
          if (done) {
            const blob = new Blob(chunks);
            const arrayBufferReader = new FileReader();
            arrayBufferReader.onload = () => resolve(arrayBufferReader.result);
            arrayBufferReader.onerror = reject;
            arrayBufferReader.readAsArrayBuffer(blob);
            return;
          }
          chunks.push(value);
          read();
        }).catch(reject);
      }
  
      read();
    });
  }
  
  var Speaking = function(state) {
    this.state = state;
    state.message = state.messages.SPEAKING;
    this.advanceConversation = function() {
      if (state.audioOutput.contentType === 'audio/mpeg' && state.audioOutput.audioArrayBuffer) {
        audioControl.play(state.audioOutput.audioArrayBuffer, function() {
          if (state.audioOutput.dialogState === 'ReadyForFulfillment' ||
              state.audioOutput.dialogState === 'Fulfilled' ||
              state.audioOutput.dialogState === 'Failed' ||
              !state.config.silenceDetection) {
            state.transition(new Initial(state));
          } else {
            audioControl.startRecording(state.onSilence, state.onAudioData, state.config.silenceDetectionConfig);
            state.transition(new Listening(state));
          }
        });
      } else {
        state.transition(new Initial(state));
      }
    };
  };
  
  var applyDefaults = function(config) {
    config = config || {};
    config.silenceDetection = config.hasOwnProperty('silenceDetection') ? config.silenceDetection : true;

    var lexConfig = config.lexConfig || {};
    // lexConfig.botAliasId = "TSTALIASID";
    lexConfig.botAliasId = lexConfig.hasOwnProperty('botAliasId') ? lexConfig.botAliasId : DEFAULT_LATEST;
    lexConfig.botId = lexConfig.hasOwnProperty('botId') ? lexConfig.botId : '';
    lexConfig.sessionId = lexConfig.hasOwnProperty('sessionId') ? lexConfig.sessionId : DEFAULT_USER_ID;
    // lexConfig.contentType = lexConfig.hasOwnProperty('contentType') ? lexConfig.contentType : DEFAULT_CONTENT_TYPE;
    // lexConfig.accept = lexConfig.hasOwnProperty('accept') ? lexConfig.accept : DEFAULT_ACCEPT_HEADER_VALUE;
    lexConfig.requestContentType = "audio/x-l16; sample-rate=16000";
    lexConfig.responseContentType = "audio/mpeg";
    lexConfig.localeId = "en_US"
    config.lexConfig = lexConfig;

    return config;
  };


  export default conversation;